<template>
  <div class="maincont child" id="activity">
    <div class="ef--inner2 filter">

      <div class="page-title">
        <h2>アカウント管理</h2>
        <a class="function-btn" href="javascript:void(0)" @click="$router.push('account/new')" v-if="$store.state.loginType == 0">アカウント新規追加</a>
      </div>

      <div id="page_info" class="page-info page-info-frame">

        <!--=============================================================---
        <--- 絞込
        <!--=============================================================-->
        <div class="block-info display-block">
          <div class="filter-info display-flex">
            <div class="header-info">条 件</div>

            <div class="line-info display-flex">
              <!------------------------------------------------------------------
              <-- お客さま名
              <------------------------------------------------------------------>
              <div class="item-info display-flex">
                <label class="title" for="company_name">お客さま名</label>
                <div class="body display-inline">
                  <input
                    type="text"
                    class="normal"
                    v-model="filter.company_name"
                  />
                </div>
              </div>

              <!------------------------------------------------------------------
              <-- アカウント種別
              <------------------------------------------------------------------>
              <div class="item-info display-flex">
                <label class="title" for="account_type">アカウント種別</label>
                <div class="body display-inline">
                  <select
                    class="small"
                    id="accountType"
                    name="accountType"
                    v-model="filter.account_type"
                  >
                    <option value = ""></option>
                    <option value = "1">グループ</option> 
                    <option value = "2">電力見える化</option> 
                    <option value = "3">ES</option> 
                  </select>
                </div>
              </div>

              <!------------------------------------------------------------------
              <-- 計測器種別
              <------------------------------------------------------------------>
              <div class="item-info display-flex">
                <label class="title" for="measure_instrument">計測器種別</label>
                <div class="body display-inline">
                  <select
                    class="small"
                    id="measure_instrument"
                    name="measure_instrument"
                    v-model="filter.measure_instrument"
                  >
                    <option value = ""></option>
                    <option value = "1">RTR-500MBS-A (旧)</option> 
                    <option value = "3">RTR500BM (新)</option> 
                    <option value = "2">WLM-PC1</option> 
                  </select>
                </div>
              </div>
            </div>

            <div class="footer-info display-flex">
              <input
                type="button"
                class="mini"
                id="filter"
                value="絞 込"
                @click="onFilter()"
              />
            </div>
          </div>
        </div>

        <!--=============================================================---
        <--- リスト(アカウント管理)
        <!--=============================================================-->
        <div class="block-info display-block">
          <div class="list-info" style="height:610px;">
            <table class="list-table">
              <thead>
                <tr>
                  <th rowspan="2" width="7%"><a href="javascript:void(0);" @click="onSort('account', 'accountSort')">アカウントNo.</a></th>
                  <th rowspan="2" ><a href="javascript:void(0);" @click="onSort('company_name', 'nameSort')">お客さま名</a></th>
                  <th rowspan="2" width="6%"><a href="javascript:void(0);" @click="onSort('account_type', 'accountTypeSort')">アカウント<br/>種 別</a></th>
                  <th rowspan="2" width="6%">アカウント<br/>詳 細</th>
                  <th rowspan="2" width="7%"><a href="javascript:void(0);" @click="onSort('amsid', 'amsidSort')">気象実況地点</a></th>
                  <th colspan="3">電力見える化</th>
                  <th colspan="3">ES</th>
                </tr>
                <tr>
                  <th width="9%"><a href="javascript:void(0);" @click="onSort('measure_instrument', 'measureInstrumentSort')">計測器種別</a></th>
                  <th width="7%"><a href="javascript:void(0);" @click="onSort('contract_power', 'contractPowerSort')">デマンド目標値</a></th>
                  <th width="7%"><a href="javascript:void(0);" @click="onSort('air_conditioner_control', 'airConditionerControlSort')">空調機制御設定</a></th>
                  <th width="7%"><a href="javascript:void(0);" @click="onSort('', 'Sort')">2値<br/>制御設定</a></th>
                  <th width="7%"><a href="javascript:void(0);" @click="onSort('', 'Sort')">数値<br/>制御設定</a></th>
                  <th width="7%"><a href="javascript:void(0);" @click="onSort('function_type', 'systemDiagramSettingSort')">系統図<br/>メンテナンス</a></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in filterAccounts" v-bind:key="index">
                  <!------------------------------------------------------------------
                  <-- アカウントNo
                  <------------------------------------------------------------------>
                  <td>{{item.account}}</td>

                  <!------------------------------------------------------------------
                  <-- お客さま名
                  <------------------------------------------------------------------>
                  <td>
                    <p v-if="item.parent_name == '' || item.parent_name == null">{{ item.company_name }} さま</p>
                    <p v-else>[ {{ item.parent_name }} ]<br>{{ item.company_name }} さま</p>
                  </td>

                  <!------------------------------------------------------------------
                  <-- アカウント種別
                  <------------------------------------------------------------------>
                  <td style="text-align:center;">{{ getAccountType(item.account_type, item.function_type) }}</td>

                  <!------------------------------------------------------------------
                  <-- アカウント詳細
                  <------------------------------------------------------------------>
                  <td style="text-align:center;"><a href="javascript:void(0)" @click="$router.push(`account/${item.account}`)">編集</a></td>

                  <!------------------------------------------------------------------
                  <-- 気象実況地点
                  <------------------------------------------------------------------>
                  <td style="text-align:center;">{{ getAmsidName(item.amsid) }}</td>

                  <!------------------------------------------------------------------
                  <-- (電力見える化)計測器種別
                  <------------------------------------------------------------------>
                  <td style="text-align:center;">{{ getInstrumentName(item.measure_instrument) }}</td>

                  <!------------------------------------------------------------------
                  <-- (電力見える化)デマンド目標値
                  <------------------------------------------------------------------>
                  <td style="text-align:right;"><span>{{ numComma(item.contract_power) }}</span> kW</td>

                  <!------------------------------------------------------------------
                  <-- (電力見える化)空調機制御設定
                  <------------------------------------------------------------------>
                  <td style="text-align:center;"><a href="javascript:void(0)" @click="$router.push(`AirConditionerSetting/${item.account}`)">{{ getSettingType(item.air_conditioner_control, item.measure_instrument) }}</a></td>

                  <!------------------------------------------------------------------
                  <-- (ES)2値制御設定
                  <------------------------------------------------------------------>
                  <td style="text-align:center;"></td>

                  <!------------------------------------------------------------------
                  <-- (ES)数値制御設定
                  <------------------------------------------------------------------>
                  <td style="text-align:center;"></td>

                  <!------------------------------------------------------------------
                  <-- (ES)系統図メンテナンス
                  <------------------------------------------------------------------>
                  <td style="text-align:center;"><a href="javascript:void(0)" @click="$router.push(`system_diagram_setting/${item.account}`)">{{ getSystemDiagramSetting(item.function_type) }}</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <LoadExternalJS :url="fixedMidashiUrl"></LoadExternalJS>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Store from "../../store";
import Axios from "axios";
import LoadExternalJS from "../../components/LoadExternalJS";

export default {
  name: "account-list",
  components: {
    LoadExternalJS
  },
  data: function() {
    return {
      accounts: [],
      filterAccounts: [], //初期化
      filter: {
        company_name: "",
        account_type: 0,
        measure_instrument: 0
      },
      fixedMidashiUrl: "./assets/js/fixed_midashi.js"
    };
  },
  updated: function() {
    window.FixedMidashi.remove();
    window.FixedMidashi.create();
  },
  computed: {
    pagenation: function() {
      const numOfPages = this.$store.state.accountList.numOfPages;
      let temp = [];
      for (let index = 0; index < numOfPages; index++) {
        temp.push(index + 1);
      }
      return temp;
    }
  },
  created: function() {
    const self = this;
    console.log("created");
    Axios.get("/srv/api/accountlist", {
      withCredentials: true
    })
      .then(response => {
        console.log("success");
        if (typeof response.data == "object") {
          console.log(response.data.account);
          self.accounts = response.data.account;
          self.filterAccounts = response.data.account;
          this.$store.dispatch("accountListPageReset", self.accounts.length);
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    getAmsidName: function(amsid) {
      const weathers = this.$store.state.weatherAreaRelationMaster.filter(
        obj => obj.amsid == amsid
      );
      if (weathers.length > 0) {
        return weathers[0].area_name;
      } else {
        return amsid;
      }
    },
    getInstrumentName: function(instrument_id){
      if (instrument_id == 1) {
        return "RTR-500MBS-A (旧)";
      } else if (instrument_id == 2) {
        return "WLM-PC1";
      } else if (instrument_id == 3) {
        return "RTR500BM (新)";
      } else {
        return "";
      }
    },

    getSettingType: function(airConditionerControl, measureInstrument) {
      if (airConditionerControl == true && measureInstrument != 1){
        return '設定';
      } else {
        return "";
      }
    },

    getSystemDiagramSetting: function(function_type) {
      if (function_type == 2) {
        return '設定';
      } else {
        return "";
      }
    },

    onFilter: function() {
      // accounts:絞り込み前の子アカウント情報
      // filterAccounts:絞り込み後の子アカウント情報
      this.filterAccounts = this.accounts;
      
      // 「さま」が検索文字列に含まれる場合、削除
      let tmpFilterName = this.filter.company_name;
      if (this.filter.company_name.indexOf("さま") > -1) {
        tmpFilterName = this.filter.company_name.slice( 0, -2 );
      }

      if (tmpFilterName) {
        // filterメソッドで条件に該当するものだけ抜き出す
        const list = this.filterAccounts.filter(
          // indexOfメソッドでaccounts.nameにtmpFilterNameが含まれるか確認
          item => (
                    ((item.company_name != null) && (item.company_name.indexOf(tmpFilterName) > -1)) ||
                    ((item.parent_name != null) && (item.parent_name.indexOf(tmpFilterName) > -1))
                  )
        );
        // 含まれたもののみfilterAccountsに格納
        this.filterAccounts = list;
      }

      if (this.filter.account_type) {
        // filterメソッドで条件に該当するものだけ抜き出す
        if (this.filter.account_type == 1) {
          const list = this.filterAccounts.filter(
            item => item.account_type == 20
          );
          this.filterAccounts = list;
        } else if (this.filter.account_type == 2) {
          const list = this.filterAccounts.filter(
            item => (item.account_type == 10 && item.function_type == 1)
          );
          this.filterAccounts = list;
        } else {
          const list = this.filterAccounts.filter(
            item => (item.account_type == 10 && item.function_type == 2)
          );
          this.filterAccounts = list;
        }
      }

      if (this.filter.measure_instrument) {
        // filterメソッドで条件に該当するものだけ抜き出す
        const list = this.filterAccounts.filter(
          // accounts.measureInstrumentとMeasureInstが一致するか確認
          item => item.measure_instrument == this.filter.measure_instrument
        );
        // 一致したもののみfilterAccountsに格納
        this.filterAccounts = list;
      }
    },

    onSort: function(type, flg) {
      console.log("onSort");
      let sortFlg = 0;

      if (this[flg] != null) {
        this[flg] = (this[flg] === 1) ? 0 : 1;
        sortFlg = this[flg];
      } else {
        this[flg] = 0;
      }

      if (flg == "accountTypeSort") {
        this.filterAccounts.sort(function(a,b){
          let data1 = a[type];
          let data2 = b[type];
          data1 -= (a['function_type']);
          data2 -= (b['function_type']);
          if (sortFlg == 0) {
            return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
          } else {
            return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
          }
        });
      } else {
        this.filterAccounts.sort(function(a,b){
          if (sortFlg == 0) {
            return (a[type] < b[type]) ? -1 : (a[type] > b[type]) ? 1 : 0;
          } else {
            return (a[type] < b[type]) ? 1 : (a[type] > b[type]) ? -1 : 0;
          }
        });
      }
    },
  }
};
</script>